import { NgModule } from '@angular/core';

import { CmsPopupComponent } from './cms-popup.component';
import {CmsModule} from '../cms.module';
import {MatDialogModule} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {ContentloaderModule} from '@signature-it/ngx-generic/components/contentloader';
import {CommonModule} from "@angular/common";

@NgModule({
    imports: [
        CmsModule,
        MatDialogModule,
        TranslateModule,
        ContentloaderModule,
        CommonModule
    ],
    exports: [CmsPopupComponent],
    declarations: [CmsPopupComponent]
})
export class CmsPopupModuleGeneric {}
